import React from 'react';
import './sensitiveFields.scss';

/** Backend column keys for PII on demand forecasting / JKLC forecast views. */
export const SENSITIVE_FIELD_KEYS = new Set([
  'dealer_name',
  'dealer',
  'account_owner',
  'account_owner_sap',
  'report_to',
  'report_to_sap',
  'epm_account_owner',
  'epm_reports_to',
  'sap_account_owner',
  'sap_reports_to',
]);

export const isSensitiveFieldKey = (key) => key != null && SENSITIVE_FIELD_KEYS.has(key);

export const SensitiveBlur = ({ children, className = '', ...rest }) => {
  if (children === null || children === undefined || children === '') {
    return null;
  }
  const classes = ['demand-forecast-sensitive', className].filter(Boolean).join(' ');
  return (
    <span className={classes} aria-label="Restricted" {...rest}>
      {children}
    </span>
  );
};

export const renderSensitiveCellValue = (
  key,
  value,
  { empty = '—', emptyNode = null } = {},
) => {
  if (value === null || value === undefined || value === '') {
    if (emptyNode) return emptyNode;
    return <span style={{ color: '#aaa' }}>{empty}</span>;
  }
  const text = typeof value === 'number' ? String(value) : value;
  if (isSensitiveFieldKey(key)) {
    return <SensitiveBlur>{text}</SensitiveBlur>;
  }
  return text;
};

export const DealerNameWithCode = ({ dealerName, dealerCode }) => {
  if (!dealerName && !dealerCode) {
    return null;
  }
  return (
    <>
      {dealerName ? <SensitiveBlur>{dealerName}</SensitiveBlur> : null}
      {dealerCode ? <span>{dealerName ? ' ' : ''}({dealerCode})</span> : null}
    </>
  );
};

export const renderSensitiveAutocompleteOption = (props, option) => {
  const { key, ...rest } = props;
  const label = option?.label ?? option?.value ?? (typeof option === 'string' ? option : '');
  return (
    <li key={key} {...rest}>
      <SensitiveBlur>{label}</SensitiveBlur>
    </li>
  );
};

export const sensitiveAutocompleteInputSx = (hasValue) =>
  hasValue
    ? { '& .MuiAutocomplete-input': { filter: 'blur(5px)', userSelect: 'none' } }
    : {};
